export enum CDN_MODULES {
  NETWORK = "network",
  PARTNERS = "partners",
  TOKEN = "token",
  DEX = "dex",
}
